import Vue from "vue";
import {Bovemij} from '../../constants'

const EventBus = new Vue();
Bovemij.EventBus = EventBus;

export {
    EventBus
}
